// Tekster for pipeline pakke 4 (maler, vinnårsaker, produkt- og kundefelt, varsler og prosjektfelt). Egen fil så delene av pakken kan
// bygges hver for seg.
export const norwegianPipelineHandoverMessages = {
  crm: {
    settings: {
      win_reasons: {
        title: "Vinnårsaker",
        help: "Årsakene vi kan velge når en mulighet vinnes. Feltet er valgfritt i dialogen. En årsak som er brukt, kan skjules, men ikke slettes.",
        label: "Navn",
        hidden: "Skjult",
        hidden_badge: "Skjult",
        add: "Legg til vinnårsak",
        save: "Lagre vinnårsakene",
        saved: "Vinnårsakene er lagret",
        save_error: "Vinnårsakene kunne ikke lagres",
        remove: "Slett vinnårsak",
        need_label: "Alle vinnårsaker må ha et navn.",
        duplicate: "To vinnårsaker kan ikke ha samme navn.",
        in_use: "Brukt på %{count} muligheter – kan bare skjules",
        in_use_error: "«%{label}» brukes av muligheter og kan bare skjules.",
      },
      project_templates: {
        title: "Prosjektmaler",
        help: "Når en mulighet vinnes, opprettes prosjektet fra en mal med statuskolonner og oppstartsoppgaver. Et produkt kan peke på en mal. Dagene i malen er virkedager i Europe/Oslo, uten helger og norske helligdager.",
        empty: "Ingen prosjektmaler ennå.",
        add: "Ny prosjektmal",
        create_title: "Ny prosjektmal",
        edit_title: "Rediger prosjektmal",
        edit_named: "Rediger %{name}",
        delete_named: "Slett %{name}",
        delete_title: "Slett prosjektmalen «%{name}»?",
        delete_content:
          "Oppgavene i malen slettes også. Produkter og prosjekter som bruker malen, beholdes uten mal.",
        deleted: "Prosjektmalen er slettet",
        summary: "%{tasks} oppgaver · %{days} virkedager · %{columns}",
        own_columns: "%{count} egne kolonner",
        default_columns: "statuser fra Innstillinger",
        hidden_badge: "Skjult",
        hidden: "Skjult (kan ikke velges for nye salg)",
        workdays_help:
          "Alle dager i malen er virkedager i Europe/Oslo. Helger og norske helligdager telles ikke.",
        name: "Malnavn",
        description: "Beskrivelse",
        duration: "Varighet (virkedager)",
        duration_help:
          "Planlagt lansering foreslås som oppstart pluss varigheten i virkedager.",
        duration_range:
          "Varigheten er et helt antall virkedager fra 0 til 1000.",
        need_name: "Malen må ha et navn.",
        statuses: "Statuskolonner",
        statuses_help:
          "Kolonnene prosjektet får. Uten egne kolonner brukes statusene fra Innstillinger → Prosjekter. Én kolonne kan være «ferdig»: oppgaver der er fullført.",
        status_label: "Kolonnenavn",
        status_color: "Farge",
        status_done: "Ferdig",
        status_add: "Legg til kolonne",
        status_remove: "Fjern kolonne",
        status_need_label: "Alle statuskolonner må ha et navn.",
        status_duplicate: "To statuskolonner kan ikke ha samme navn.",
        tasks: "Oppgaver",
        tasks_help:
          "«Virkedag N» betyr N virkedager etter planlagt oppstart (0 er oppstartsdagen). Helger og norske helligdager hoppes over. Milepæler er vanlige oppgaver uten beløp.",
        task_title: "Tittel",
        task_day: "Virkedag etter oppstart",
        task_role: "Rolle",
        task_section: "Statuskolonne",
        task_type: "Oppgavetype",
        task_add: "Legg til oppgave",
        task_remove: "Fjern oppgave",
        task_need_title: "Alle oppgaver må ha en tittel.",
        task_day_range: "Virkedag er et helt tall fra 0 til 1000.",
        section_first: "Første kolonne",
        order: "Rekkefølge",
        save: "Lagre prosjektmalen",
        saved: "Prosjektmalen er lagret",
        save_error: "Prosjektmalen kunne ikke lagres",
        role: {
          project_lead: "Prosjektansvarlig",
          deal_owner: "Mulighetens eier",
          billing_admin: "Fakturaansvarlig",
        },
      },
      won_emails: {
        title: "E-postmaler for salg",
        help: "Utkastene Mimin lager når en mulighet vinnes. De åpnes i ditt eget e-postprogram, så du kan se over teksten før du sender. Et tomt flettefelt fjernes fra teksten.",
        review_url: "Anmeldelseslenke",
        review_url_help: "For eksempel lenken til anmeldelser på Google.",
        website: "Nettsted",
        merge_fields: "Flettefelt",
        reset: "Tilbakestill",
        reset_named: "Tilbakestill %{name}",
        subject_named: "Emne: %{name}",
        body_named: "Tekst: %{name}",
        template: {
          thanks: "Takk etter Vunnet",
          review: "Be om anmeldelse",
        },
        field: {
          contact_first_name: "Kontaktens fornavn",
          company_name: "Firmanavnet fra Innstillinger",
          deal_title: "Mulighetens tittel",
          suggested_date: "Planlagt oppstart (dd.mm.åååå)",
          sender_name: "Ditt navn",
          project_name: "Prosjektets navn",
          review_url: "Anmeldelseslenken over",
          website: "Nettstedet over",
        },
      },
    },
    company_handover: {
      customer_since: "Kunde siden %{date}",
      waiting_tripletex: "Venter på Tripletex-kunde",
      waiting_tripletex_help:
        "Kunden har løpende produkter, men er ikke opprettet i Tripletex. Abonnementet kommer med i fakturagrunnlaget når kunden er opprettet i Tripletex og synket.",
    },
    project_handover: {
      title: "Oppstart og overlevering",
      no_template: "Ingen mal",
      launch_help:
        "Endrer du lanseringsdatoen, flyttes «Be om anmeldelse» og «Kundesjekk» tilsvarende.",
      launch_before_start: "Lansering kan ikke være før oppstart.",
      launch_saved:
        "Lanseringsdatoen er lagret. Oppgavene som avhenger av den, er flyttet.",
      start_saved: "Oppstartsdatoen er lagret.",
    },
    project_history: {
      tab: "Salgshistorikk",
      read_only: "Kun lesing",
      empty: "Muligheten har ingen notater eller hendelser.",
      automation: "Automatisk",
      pinned: "Festet",
      event: {
        created: "Muligheten ble opprettet",
        lead_created: "Leaden ble opprettet",
        won: "Markert som vunnet",
        lost: "Markert som tapt",
        reopened: "Gjenåpnet",
        disqualified: "Diskvalifisert",
        stage: "Flyttet fra %{from} til %{to}",
        value: "Verdien ble endret",
        owner: "Ny eier",
        probability: "Sannsynligheten ble endret",
        loss_reason: "Tapsårsaken ble endret",
        archived: "Arkivert",
        restored: "Gjenopprettet",
      },
    },
    dashboard: {
      today: {
        group: { notifications: "Varsler" },
        mark_read: "Marker som lest",
        mark_read_named: "Marker som lest: %{text}",
      },
    },
  },
  resources: {
    products: {
      fields: {
        billing_interval: "Periode",
        project_template_id: "Prosjektmal",
      },
      sections: { sales: "Salg og oppstart" },
      billing_interval: {
        one_time: "Engangs",
        monthly: "Månedlig",
        quarterly: "Kvartal",
        yearly: "År",
      },
      helper: {
        billing_interval:
          "Gjentakende perioder blir kundeprodukter når en mulighet vinnes. Engangs faktureres manuelt.",
        project_template_id: "Vunnet foreslår denne malen for prosjektet.",
      },
      no_template: "Ingen mal",
    },
    companies: {
      fields: {
        company_kind: "Type",
        customer_since: "Kunde siden",
      },
      company_kind: {
        business: "Bedrift",
        private: "Privat",
      },
    },
    projects: {
      fields: {
        planned_start: "Planlagt oppstart",
        planned_launch: "Planlagt lansering",
        template_id: "Prosjektmal",
        handover_summary: "Overleveringsoppsummering",
      },
    },
  },
};

export const englishPipelineHandoverMessages = {
  crm: {
    settings: {
      win_reasons: {
        title: "Win reasons",
        help: "The reasons we can choose when an opportunity is won. The field is optional in the dialog. A reason that has been used can be hidden, but not deleted.",
        label: "Name",
        hidden: "Hidden",
        hidden_badge: "Hidden",
        add: "Add win reason",
        save: "Save win reasons",
        saved: "The win reasons have been saved",
        save_error: "The win reasons could not be saved",
        remove: "Delete win reason",
        need_label: "Every win reason needs a name.",
        duplicate: "Two win reasons cannot have the same name.",
        in_use: "Used on %{count} opportunities – can only be hidden",
        in_use_error:
          "“%{label}” is used by opportunities and can only be hidden.",
      },
      project_templates: {
        title: "Project templates",
        help: "When an opportunity is won, the project is created from a template with status columns and start-up tasks. A product can point to a template. Days in a template are working days in Europe/Oslo, excluding weekends and Norwegian public holidays.",
        empty: "No project templates yet.",
        add: "New project template",
        create_title: "New project template",
        edit_title: "Edit project template",
        edit_named: "Edit %{name}",
        delete_named: "Delete %{name}",
        delete_title: "Delete the project template “%{name}”?",
        delete_content:
          "The template's tasks are deleted too. Products and projects using the template are kept without a template.",
        deleted: "The project template has been deleted",
        summary: "%{tasks} tasks · %{days} working days · %{columns}",
        own_columns: "%{count} own columns",
        default_columns: "statuses from Settings",
        hidden_badge: "Hidden",
        hidden: "Hidden (cannot be chosen for new sales)",
        workdays_help:
          "All days in the template are working days in Europe/Oslo. Weekends and Norwegian public holidays are not counted.",
        name: "Template name",
        description: "Description",
        duration: "Duration (working days)",
        duration_help:
          "The planned launch is suggested as the start plus the duration in working days.",
        duration_range:
          "The duration is a whole number of working days from 0 to 1000.",
        need_name: "The template needs a name.",
        statuses: "Status columns",
        statuses_help:
          "The columns the project gets. Without its own columns, the statuses from Settings → Projects are used. One column can be “done”: tasks there are completed.",
        status_label: "Column name",
        status_color: "Colour",
        status_done: "Done",
        status_add: "Add column",
        status_remove: "Remove column",
        status_need_label: "Every status column needs a name.",
        status_duplicate: "Two status columns cannot have the same name.",
        tasks: "Tasks",
        tasks_help:
          "“Working day N” means N working days after the planned start (0 is the start day). Weekends and Norwegian public holidays are skipped. Milestones are ordinary tasks without amounts.",
        task_title: "Title",
        task_day: "Working day after start",
        task_role: "Role",
        task_section: "Status column",
        task_type: "Task type",
        task_add: "Add task",
        task_remove: "Remove task",
        task_need_title: "Every task needs a title.",
        task_day_range: "The working day is a whole number from 0 to 1000.",
        section_first: "First column",
        order: "Order",
        save: "Save project template",
        saved: "The project template has been saved",
        save_error: "The project template could not be saved",
        role: {
          project_lead: "Project lead",
          deal_owner: "Opportunity owner",
          billing_admin: "Billing admin",
        },
      },
      won_emails: {
        title: "Sales email templates",
        help: "The drafts Mimin creates when an opportunity is won. They open in your own email program, so you can review the text before sending. An empty merge field is removed from the text.",
        review_url: "Review link",
        review_url_help: "For example the link to reviews on Google.",
        website: "Website",
        merge_fields: "Merge fields",
        reset: "Reset",
        reset_named: "Reset %{name}",
        subject_named: "Subject: %{name}",
        body_named: "Body: %{name}",
        template: {
          thanks: "Thank you after Won",
          review: "Ask for a review",
        },
        field: {
          contact_first_name: "The contact's first name",
          company_name: "The company name from Settings",
          deal_title: "The opportunity's title",
          suggested_date: "Planned start (dd.mm.yyyy)",
          sender_name: "Your name",
          project_name: "The project's name",
          review_url: "The review link above",
          website: "The website above",
        },
      },
    },
    company_handover: {
      customer_since: "Customer since %{date}",
      waiting_tripletex: "Waiting for Tripletex customer",
      waiting_tripletex_help:
        "The customer has active products but has not been created in Tripletex. The subscription is included in the billing basis once the customer is created in Tripletex and synced.",
    },
    project_handover: {
      title: "Start-up and handover",
      no_template: "No template",
      launch_help:
        "If you change the launch date, “Ask for a review” and “Customer check” move accordingly.",
      launch_before_start: "The launch cannot be before the start.",
      launch_saved:
        "The launch date has been saved. The tasks that depend on it have been moved.",
      start_saved: "The start date has been saved.",
    },
    project_history: {
      tab: "Sales history",
      read_only: "Read only",
      empty: "The opportunity has no notes or events.",
      automation: "Automatic",
      pinned: "Pinned",
      event: {
        created: "The opportunity was created",
        lead_created: "The lead was created",
        won: "Marked as won",
        lost: "Marked as lost",
        reopened: "Reopened",
        disqualified: "Disqualified",
        stage: "Moved from %{from} to %{to}",
        value: "The value was changed",
        owner: "New owner",
        probability: "The probability was changed",
        loss_reason: "The loss reason was changed",
        archived: "Archived",
        restored: "Restored",
      },
    },
    dashboard: {
      today: {
        group: { notifications: "Notifications" },
        mark_read: "Mark as read",
        mark_read_named: "Mark as read: %{text}",
      },
    },
  },
  resources: {
    products: {
      fields: {
        billing_interval: "Period",
        project_template_id: "Project template",
      },
      sections: { sales: "Sales and start-up" },
      billing_interval: {
        one_time: "One-time",
        monthly: "Monthly",
        quarterly: "Quarterly",
        yearly: "Yearly",
      },
      helper: {
        billing_interval:
          "Recurring periods become customer products when an opportunity is won. One-time amounts are invoiced manually.",
        project_template_id: "Won suggests this template for the project.",
      },
      no_template: "No template",
    },
    companies: {
      fields: {
        company_kind: "Type",
        customer_since: "Customer since",
      },
      company_kind: {
        business: "Business",
        private: "Private",
      },
    },
    projects: {
      fields: {
        planned_start: "Planned start",
        planned_launch: "Planned launch",
        template_id: "Project template",
        handover_summary: "Handover summary",
      },
    },
  },
};
